export default __webpack_public_path__ + "static/sc-18a0117c15355203fa257ce1071d329b.png";